<template>
  <div>
    <div id="app">
      <div>
        <div class="bouncefix"></div>
        <router-view class="pageview" />
        <NavBar v-if="!keyboard"></NavBar>
      </div>
    </div>
    <modal />
  </div>
</template>

<script>
/* JS IMPORTS */
import * as CCDb from "@/utilities/db.js";
window.CCDb = CCDb;
import { authReady } from "./utilities/firebase";
import * as nativeLink from "./utilities/nativeLink";
/* COMPONENT IMPORTS */
import NavBar from "./components/Layout/Navbar.vue";
import Modal from "./components/Layout/Modal.vue";
export default {
  name: "app",
  components: {
    NavBar,
    Modal,
  },
  data() {
    return {
      shouldShowWalk: true,
      keyboard: false,
      currentReward: null,
      currentStep: -1,
      myCallbacks: {
        onPreviousStep: this.previousStep,
        onNextStep: this.nextStep,
      },
    };
  },
  beforeMount() {
    // SplashScreen.hide();
    //   $_('preloader').style.display = 'none'
  },
  async mounted() {
    let currentBg = getCssVar("layout-bg");
    $_("preloader").style.display = "none";
    $$("[data-statusbar-color]").forEach((x) => x.attr("content", currentBg));
    this.bgInterval = setInterval(
      () =>
        currentBg !== getCssVar("layout-bg")
          ? $$("[data-statusbar-color]").forEach((x) =>
              x.attr("content", getCssVar("layout-bg"))
                ? null
                : x.attr("content", currentBg)
            )
          : null,
      1000
    );
    let resizeTimer;
    this.onResize = () => {
      document.body.classList.add("resize-animation-stopper");
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        document.body.classList.remove("resize-animation-stopper");
      }, 400);
    };
    window.addEventListener("resize", this.onResize);
    const _this = this;
    await authReady;
    await this.$root.initLoadChores();

    // The session is already restored by the time authReady resolves, so
    // there is no need to poll for it. An anonymous session is a child device
    // that is pairing, it is not a family account.
    if (CCDb.currentUser()) {
      const profile = await CCDb.getUserProfile();
      const logins = profile.get("logins") || [];
      logins.push(Date.now());
      profile.set("logins", logins);
      await profile.save();
    }
  },
  beforeDestroy() {
    clearInterval(this.bgInterval);
    window.removeEventListener("resize", this.onResize);
  },
  watch: {
    "$root.$data.locked": async function (updated, old) {},
  },
};
</script>

<style lang="scss">
@import "./styles/main.scss";

.pageview {
  -webkit-overflow-scrolling: touch;
  overflow: scroll;
  padding-top: 0;
  grid-template-rows: auto 1fr;
  height: 100vh;
}
.oneui {
  background: var(--layout-bg);
  overflow-y: scroll;
  overflow-x: hidden;
  position: relative;
  -webkit-overflow-scrolling: touch;
}

.bouncefix {
  position: fixed;
  z-index: -1;
  width: 100%;
  height: 100vw;
  background: linear-gradient(
    var(--layout-bg) 0%,
    var(--layout-bg) 50%,
    var(--theme-color-1) 100%
  );
}
</style>
